import AxiosInstance from "@/config/AxiosInstance";
import { API_BASE_URL } from "@/config/appConfig";

type MorganStanleyLocationId = string | number;
type MorganStanleyRequestPayload = Record<string, unknown>;

export const morganStanleyService = {
  getMSStaticData,
  getBriefDetails,
  saveActionBrief,
  checkValidationMsid,
};

function getMSStaticData() {
  return AxiosInstance.get(`${API_BASE_URL}/getActionBriefDropdownList`);
}

function getBriefDetails(locationId: MorganStanleyLocationId) {
  return AxiosInstance.get(`${API_BASE_URL}/getBriefDetails/${locationId}`);
}

function saveActionBrief(data: MorganStanleyRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL}/saveActionBrief`, data);
}

function checkValidationMsid(data: MorganStanleyRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL}/checkValidationMsid`, data);
}
